export default {
  slices: [
    {
      field: 'ad_type',
      display: 'Ad Type',
      map: {
        'tv': {
          display: 'TV',
          sortOrder: 1
        },
        'online_video': {
          display: 'OLV',
          sortOrder: 2
        },
        'social_media': {
          display: 'Social Media',
          sortOrder: 3
        },
        'online_display': {
          display: 'Online Display',
          sortOrder: 4
        },
        'print': {
          display: 'Print',
          sortOrder: 5
        }
      }
    },
    {
      field: 'target',
      display: 'Target',
      useInQuery: true,
      map: {
        'adult_sufferers': {
          display: 'Adult Sufferers',
          sortOrder: 1
        },
        'caregivers': {
          display: 'Caregivers',
          sortOrder: 2
        }
      }
    },
    {
      field: 'ad_categories',
      display: 'Ad Category',
      hidden: true,
      map: {
        'atopic_dermatitis': {
          display: 'Atopic Dermatitis',
          sortOrder: 1,
        }
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/config/metadata.js